// extracted by mini-css-extract-plugin
export default {"terms":"application-module__terms--e5u"};